import Alert from "react-bootstrap/Alert";
import { IoAlertOutline } from "react-icons/io5";

import ImageSet from "../ImageSet";
import Translated from "../Translated";
import classNames from "classnames";
import Spinner from "../Spinner";
import { useSubcategories } from "../../../api-new";

const ShopCategorySelector = (props) => {
  const subcategoriesQuery = useSubcategories("teaching_permit", props.lang);

  if (subcategoriesQuery.isPending) {
    return <Spinner />;
  } else if (subcategoriesQuery.isError) {
    return (
      <Alert>
        <IoAlertOutline />{" "}
        <Translated translationKey={subcategoriesQuery.error.message} />
      </Alert>
    );
  }

  const categories = subcategoriesQuery.data.subCategories; //Format is [{category: "CATEGORY_NAME", orderNo: 1}, ...]
  const productsPages = subcategoriesQuery.data.productsPages;

  // Map static categories to include sortNo
  const staticPagesWithSort = categories.map((categoryObj) => ({
    sortNo: categoryObj.orderNo, // or categoryObj.sortNo if available
    element: (
      <div
        className="shop-category-selector-item touchable"
        onClick={() => props.onCategorySelect(categoryObj.category)}
        key={categoryObj.category}
      >
        <div className="heavy-bump-once">
          <ImageSet src={"../../assets/category/" + categoryObj.category.toLowerCase() + "_white.png"} alt={"License category icon " + categoryObj.category} />
          <div className="title">
            <Translated translationKey={"category_" + categoryObj.category} />
          </div>
        </div>
      </div>
    )
  }));

  // Map product pages to include sortNo
  const productsPagesWithSort = productsPages.map(productsPage => ({
    sortNo: productsPage.orderNo,
    element: (
      <div
        className="shop-category-selector-item touchable"
        onClick={() => props.onProductsPageSelect(productsPage)}
        key={productsPage.id}
      >
        <div className="heavy-bump-once">
          {productsPage.imageFile && <ImageSet src={productsPage.imageFile} />}
          <div className="title">{productsPage.title}</div>
        </div>
      </div>
    )
  }));

  // Combine and sort by sortNo
  const allPages = [...staticPagesWithSort, ...productsPagesWithSort]
    .sort((a, b) => a.sortNo - b.sortNo)
    .map(item => item.element);

  const useNarrow = (categories.length + productsPages.length) % 2 === 0;
  const classes = classNames("shop-category-selector-items fade-in", {
    narrow: useNarrow,
  });

  return <div className={classes}>{allPages}</div>;
};

export default ShopCategorySelector;
